/* eslint-disable camelcase */
import { parse, stringify } from "query-string";
import { FC, useEffect, useState } from "react";

import {
  DefaultButton,
  DirectionalHint,
  MessageBar,
  MessageBarType,
  Stack,
  TooltipHost
} from "@bps/fluent-ui";
import { appContext } from "@libs/config/app-context.utils.ts";
import { useStores } from "@stores/hooks/useStores.ts";

import { useIntegrationScreenContext } from "../../context/IntegrationScreenContext.ts";

export const XeroButton: FC = () => {
  const { customIntegrationXero } = useStores();
  // To determine that the URL is not OMNI but Xero
  const atXeroURL = window.location.href.includes("code=");

  const XEROBASEURL = "https://login.xero.com/identity/connect/authorize?";

  // ClientId\RedirectUri (taken from our keyvault). Scope is hard coded for now.
  const queryParams = {
    response_type: "code",
    client_id: appContext.config.xeroClientId,
    redirect_uri: appContext.config.xeroRedirectUrl,
    scope:
      "offline_access openid profile email accounting.transactions accounting.settings accounting.contacts"
  };

  const context = useIntegrationScreenContext();

  const xeroConnectString = XEROBASEURL + stringify(queryParams);

  const searchQueryParsed = parse(window.location.search);

  const authorizationCode =
    typeof searchQueryParsed.code === "string" ? searchQueryParsed.code : "";

  const errorGettingCode =
    typeof searchQueryParsed.error === "string" ? searchQueryParsed.error : "";

  const [errorGettingTenantId, setErrorGettingTenantId] = useState<
    string | undefined
  >(undefined);

  useEffect(() => {
    async function xeroToken() {
      // have re-directed to Xero.
      if (atXeroURL) {
        if (errorGettingCode === "") {
          try {
            await customIntegrationXero.addXeroTenant(authorizationCode);
            setErrorGettingTenantId("");
          } catch (err) {
            setErrorGettingTenantId(err.message);
          }
        } else {
          setErrorGettingTenantId(
            "There was an error retrieving the Xero token"
          );
        }
        // Return to OMNI without re-freshing
        window.history.pushState({}, "", appContext.config.xeroRedirectUrl);
      }
    }
    xeroToken();
  }, [atXeroURL, authorizationCode, customIntegrationXero, errorGettingCode]);

  return (
    <Stack>
      <TooltipHost
        content="Will redirect to Xero Login"
        directionalHint={DirectionalHint.leftTopEdge}
      >
        <DefaultButton text="Connect to Xero" href={xeroConnectString} />
      </TooltipHost>
      <br />
      {errorGettingCode && (
        <MessageBar messageBarType={MessageBarType.error}>
          There was an error retrieving the Authentication code:
          <br />
          {errorGettingCode}
        </MessageBar>
      )}
      {errorGettingTenantId && (
        <MessageBar messageBarType={MessageBarType.error}>
          There was an error retrieving the Xero token:
          <br />
          {errorGettingTenantId}
        </MessageBar>
      )}
      {errorGettingTenantId === "" && context.xeroTenantId && (
        <MessageBar messageBarType={MessageBarType.success}>
          A Xero token has been successfully retrieved.
        </MessageBar>
      )}
    </Stack>
  );
};
